import { render } from "./RawMaterials.vue?vue&type=template&id=81b812a2"
import script from "./RawMaterials.vue?vue&type=script&lang=ts"
export * from "./RawMaterials.vue?vue&type=script&lang=ts"
script.render = render

export default script